module.exports = __webpack_public_path__ + "static/img/cont33_02.4aae925.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont33_02.jpg
// module id = kOh0
// module chunks = 0